import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="simulation-progress"
export default class extends Controller {
	static values = {
		complete: { type: Boolean, default: false },
		failed: { type: Boolean, default: false },
	}

	connect() {
		// if (this.completeValue && !this.failedValue) this.hideModalSimulieren() Wird erst wieder relevant, wenn wir etwas anderes machen wollen als Modal schließen
		if (this.completeValue) this.hideModalSimulieren()
	}

	// Private

	hideModalSimulieren() {
		setTimeout(() => {
			const modalSimulieren = document.querySelector("#modal_simulieren")

			if (modalSimulieren) modalSimulieren.innerHTML = ""
		}, 800)
	}
}
